import { FormItem } from '@framework/form/item/FormItem.tsx';
import { RowElement } from '@framework/ui/components/row/RowElement.tsx';
import { ComputeExpressionInput } from '../../../expressions/compute/input/ComputeExpressionInput.tsx';
import { type IWidgetComponentProps } from '../../IWidgetType.ts';
import { WidgetType } from '../../Widget.ts';
import { LayoutHideConfigInput } from '../common/config/LayoutHideConfigInput.tsx';
import { LayoutRemoveBorderConfigInput } from '../common/config/LayoutRemoveBorderConfigInput.tsx';
import { CodeLabelInputForm } from '../inputs/common/CodeLabelInputForm.tsx';
import { getWidgetProps } from '../inputs/common/util/getWidgetProps.ts';
import { type IComputedWidget } from './IComputedWidget.ts';

export interface ICommonComputedWidgetConfigComponentProps
  extends IWidgetComponentProps<IComputedWidget> {
  expressionLabel?: string;
}

/**
 * Form di configurazione widget calcolati
 */
export function CommonComputedWidgetConfigComponent(
  props: ICommonComputedWidgetConfigComponentProps,
) {
  const { widget, expressionLabel } = props;
  const options = getWidgetProps(props);
  return (
    <div>
      {/* Form Codice + Etichetta */}
      <CodeLabelInputForm widgetOptions={options} />

      <FormItem
        name={['expression.raw', 'expression.value']}
        label={expressionLabel ?? 'Espressione'}
      >
        <ComputeExpressionInput
          name="expression"
          widgetId={widget.id}
          includeSelf={false}
          noFunctions={widget.type === WidgetType.ComputedString}
        />
      </FormItem>

      <RowElement>
        <LayoutHideConfigInput />
        <LayoutRemoveBorderConfigInput />
      </RowElement>
    </div>
  );
}
